"use client";

import { TeamMemberMorphContextType } from "@entities/team-member/model/index";
import { useBreakpoints } from "@shared/lib/breakpoints";
import { createContext, type PropsWithChildren } from "react";
import { useMorphs } from "react-morph";
import type { TeamMember } from "../types";

export const Context = createContext<TeamMemberMorphContextType>(
  {} as TeamMemberMorphContextType
);

export type ContextProviderProps = PropsWithChildren<{
  teamMembers: TeamMember[];
}>;

export function ContextProvider({
  teamMembers,
  children,
}: ContextProviderProps) {
  const morphs = useMorphs(teamMembers);
  const { isLg } = useBreakpoints();

  return (
    <Context.Provider value={{ morphs, enabled: isLg, teamMembers }}>
      {children}
    </Context.Provider>
  );
}
